import { Stethoscope } from "lucide-react";
import { ehPapelDeDentista } from "@bookdental/schemas";
import { useAuth } from "@/lib/auth";
import { trpc } from "@/lib/trpc";

/** Quem pede sem ser dentista (recepção, assistente) escolhe por qual dentista o pedido vai.
 *  Dentista pedindo responde pelo próprio pedido — o servidor usa ele mesmo. */
export function usePrecisaEscolherDentista() {
  const { user } = useAuth();
  return !ehPapelDeDentista(user?.activeOrganization?.role);
}

export function CampoDentistaResponsavel({ valor, onChange }: { valor: string; onChange: (id: string) => void }) {
  const precisa = usePrecisaEscolherDentista();
  const dentistasQuery = trpc.organization.listDentists.useQuery({ apenasAtivos: true }, { enabled: precisa, staleTime: 60_000 });
  if (!precisa) return null;

  return (
    <div className="flex flex-col gap-1.5 rounded-lg border border-amber-200 bg-amber-50/60 px-3 py-2 sm:max-w-sm dark:border-amber-500/30 dark:bg-amber-500/10">
      <label
        htmlFor="dentista-responsavel"
        className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-amber-700 dark:text-amber-400"
      >
        <Stethoscope className="h-3.5 w-3.5" />
        Dentista responsável — obrigatório
      </label>
      <select
        id="dentista-responsavel"
        value={valor}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 w-full rounded-md border border-zinc-200 bg-white px-3 text-sm text-zinc-900 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-border dark:bg-card dark:text-foreground"
      >
        <option value="">Selecione</option>
        {(dentistasQuery.data ?? []).map((d) => (
          <option key={d.id} value={d.id}>
            {d.name ?? "Sem nome"}
          </option>
        ))}
      </select>
    </div>
  );
}
